import { useState, useCallback, useMemo } from 'react';
import useSSE from '../../../hooks/useSSE';
import { sseAuthConfig } from '../../../constants/sseAuth';
import { SSE_URL } from '../constants';
import { trackEvent } from '../../../modules/analytics/trackingMiddleware';
import { NOTIFICATION_OPENED } from '../../../modules/analytics/events';

export function useNotificationsCount() {
  const backendApi = import.meta.env.VITE_APP_NOTIFICATION_ENDPOINT;
  const {
    data,
    error,
    isConnecting,
    isOpen: isConnectionOpen,
    isClosed: isConnectionClosed,
    connect,
    disconnect,
    reconnect,
  } = useSSE(`${backendApi}${SSE_URL}`, {
    ...sseAuthConfig(),
    autoReconnect: true,
    maxReconnectAttempts: 3,
    reconnectInterval: 3000,
  });

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      trackEvent(NOTIFICATION_OPENED, { unreadCount: data?.count ?? 0 });
    },
    []
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const notificationCount = data?.count;
  const count = useMemo(() => (typeof notificationCount === 'number' ? notificationCount : 0), [notificationCount]);
  const isModalOpen = Boolean(anchorEl);

  return {
    anchorEl,
    isModalOpen,
    count,
    error,
    isConnecting,
    isConnectionOpen,
    isConnectionClosed,
    connect,
    disconnect,
    reconnect,
    handleClick,
    handleClose,
  };
}